import React from 'react';
import CountUp from 'react-countup';
import './Statistics.css';

const Statistics = () => {
    return (
        <section className="statistics" id="statistics">
            <div className="container">
                <div className="stat-item">
                    <h3>
                        <CountUp end={1500} duration={3} />
                    </h3>
                    <p>Пользователей</p>
                </div>
                <div className="stat-item">
                    <h3>
                        <CountUp end={3000} duration={3} />
                    </h3>
                    <p>Запросов в день</p>
                </div>
                <div className="stat-item">
                    <h3>
                        <CountUp end={95} duration={3} suffix="%" />
                    </h3>
                    <p>Точность данных</p>
                </div>
            </div>
        </section>
    );
};

export default Statistics;
